module.exports = __webpack_public_path__ + "static/media/108.ef551bb9.png";